import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import * as Dialog from '@radix-ui/react-dialog';

const fadeIn = keyframes`
  from { opacity: 0 }
  to { opacity: 1 }
`;

const slideUp = keyframes`
  from { transform: translateY(12px); opacity: 0 }
  to { transform: translateY(0); opacity: 1 }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  @media (min-width: 768px) { left: var(--sidebar-width, 0px); }
  background: rgba(5, 7, 12, 0.5);
  z-index: 1003;
  animation: ${fadeIn} 160ms ease-out both;
`;

export const ModalShell = styled.div`
  position: fixed;
  inset: 0;
  @media (min-width: 768px) { left: var(--sidebar-width, 0px); }
  z-index: 1003;
  display: grid;
  place-items: center;
  pointer-events: none;
`;

export const EditDialog = styled.div`
  width: calc(100% - 32px);
  max-width: 480px;
  pointer-events: auto;
  animation: ${slideUp} 200ms ease-out both;
`;

export const BillingDetailsLabel = styled.label`
  color: #b7bdcb;
  font-size: 13px;
  font-family: Inter;
  font-weight: 500;
  line-height: 13px;
  word-wrap: break-word;
`;

export const ValidationMessage = styled.span`
  color: #b94c37;
  font-size: 12px;
  font-family: Inter;
  font-weight: 400;
  word-wrap: break-word;
`;

export const ModalOverlay = styled(Dialog.Overlay)`
  position: fixed;
  inset: 0;
  @media (min-width: 768px) { left: var(--sidebar-width, 0px); }
  background: rgba(10, 12, 16, 0.55);
  -webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(2px);
  z-index: 1003;
`;

export const ModalContent = styled(Dialog.Content)`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  @media (min-width: 768px) { left: calc(50% + var(--sidebar-width, 0px) / 2); }
  width: calc(100% - 64px);
  color: #0f1116;
  border-radius: 16px;
  border: 1px solid rgba(15, 17, 22, 0.08);
  box-shadow: 0 24px 72px rgba(0, 0, 0, 0.35);
  padding: 20px;
  z-index: 1003;
  background: #1e1f22;
  display: flex;
  gap: 16px;
  flex-direction: column;
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
`;

export const DiscardButton = styled.button`
  color: #b7bdcb;
  background: transparent;
  border: none;
  cursor: pointer;

  font-size: 15px;
  font-family: Inter;
  font-weight: 600;
  line-height: 21px;
  word-wrap: break-word;
`;

export const SaveButton = styled.button`
  border: none;
  width: 96px;
  height: 44px;
  padding: 12px 16px;
  background: #5e84ed;
  overflow: hidden;
  border-radius: 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  display: inline-flex;
  color: white;
  font-size: 15px;
  font-family: Inter;
  font-weight: 600;
  line-height: 21px;
  word-wrap: break-word;
  cursor: pointer;
`;
